<form nz-form [formGroup]="justificativaForm" (ngSubmit)="salvarObservacoes()">
  <div class="row">
    <div class="col-sm-12">
      <p class="text-primary-color text-center fs-5">{{ acao == 'ativar' ? 'Reativar a Mudança' : 'Inativar a Mudança' }}</p>
    </div>
    <div class="col-sm-12">
      <div class="pt-3 rounded-3 bg-light-color">
        <nz-descriptions>
          <nz-descriptions-item nzTitle="Nome da entidade" [nzSpan]="3">{{ movimentacao?.nomeEntidade }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Id de mudança" [nzSpan]="3">{{ movimentacao?.id }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Tipo de mudança" [nzSpan]="3">{{ movimentacao?.tipoMudanca }}</nz-descriptions-item>
        </nz-descriptions>
      </div>
    </div>
    <div class="col-sm-12 mt-3">
      <nz-form-item>
        <nz-form-label [nzSm]="4"  class="form-label">{{ acao == 'ativar' ? 'Justificativa da reativação:' : 'Justificativa da inativação:' }}</nz-form-label>
        <nz-form-control [nzSm]="20">
          <textarea nz-input rows="4" formControlName="textoJustificativa" ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div class="row justify-content-end mt-3">
    <div class="col-sm-auto">
      <nz-form-item>
        <nz-form-control [nzOffset]="4" [nzSm]="20">
          <button nz-button nzType="default" type="button" (click)="fecharModal()">Cancelar</button>
          <button nz-button nzType="primary" type="submit" [disabled]="justificativaForm.invalid" class="ms-2">Adicionar</button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
